howspace.widgets.onEvent('discussion:categorization:completed', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
    // Display the notification message including the number of categorized and uncategorized comments.
    real.notification.show(notification.object.error, 'danger', true);
    const categorizedCount = notification.object.categorization_counts.categorized;
    const uncategorizedCount = notification.object.categorization_counts.uncategorized;

    // Wait 350 ms before showing the notification to ensure the UI is ready.
    setTimeout(() => {
        if (uncategorizedCount > 0) {
            real.notification.show(howspace.translate('discussion_ai_categorization_completed_message_incomplete',
                {
                    'categorized_count': categorizedCount,
                    'uncategorized_count': uncategorizedCount
                }), 'info', true);
        } else {
            real.notification.show(howspace.translate('discussion_ai_categorization_completed_message_complete',
                {
                    'categorized_count': categorizedCount
                }), 'info', true);
        }
    }, 500);

});
